import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type VixioClient = SupabaseClient<any, string, any>;

let singleton: VixioClient | null = null;
let endpoint: { url: string; anonKey: string } | null = null;

/** Cliente Supabase único do app (auth + PostgREST com `.schema('<módulo>')`). */
export function createVixioClient(url: string, anonKey: string): VixioClient {
  endpoint = { url: url.replace(/\/+$/, ""), anonKey };
  singleton = createClient(url, anonKey, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: "implicit" },
    db: { schema: "core" },
  }) as VixioClient;
  return singleton;
}

export function getClient(): VixioClient {
  if (!singleton) throw new Error("Cliente Supabase não inicializado: chame createVixioClient no início do app.");
  return singleton;
}

/** Endereço da API e chave pública do cliente (envio de arquivo com progresso direto à API do Storage). */
export function getClientEndpoint(): { url: string; anonKey: string } | null {
  return endpoint;
}

/** Só para testes. */
export function setClientForTests(c: VixioClient | null, ep: { url: string; anonKey: string } | null = null): void {
  singleton = c;
  endpoint = ep;
}
